export var ROUTE_PRIVATE = Symbol('route-private');
//# sourceMappingURL=privates.js.map